import { BLOCK_TYPES, INPUT_TYPE } from 'constant/form-builder';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Input from 'components/form/Input';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import React from 'react';
import TitleBlock from './form-builder/TitleBlock';
import QuestionBlock from './form-builder/QuestionBlock';
import DividerBlock from './form-builder/DividerBlock';
import TableBlock from './form-builder/TableBlock';
import HelpContentModal from './form-builder/HelpContentModal';

const CheckboxGroup = ({ choices, value, onChange, disabled, size }) => {
  const handleChange = (val) => (e) => {
    const { checked } = e.target;
    value = Array.isArray(value) ? value : [];
    if (!checked) {
      onChange({
        target: {
          value: value.filter((i) => i !== val),
        },
      });
    } else {
      onChange({
        target: {
          value: [...value, val],
        },
      });
    }
  };

  return (
    <FormGroup>
      {choices.map((i, idx) => (
        <FormControlLabel
          classes={{
            label: 'checkbox-label'
          }}
          key={idx}
          value={i}
          control={
            <Checkbox
              size={size}
              readOnly={disabled}
              checked={value?.includes(i)}
              onChange={handleChange(i)}
            />
          }
          label={i}
        />
      ))}
    </FormGroup>
  );
};

export const makeInput = (config) => {
  const {
    questionType = INPUT_TYPE.TEXT,
    question,
    placeholder,
    helpContent,
    choices,
    value,
    name,
    onChange,
    viewOnly,
    readOnly,
    classes
  } = config;
  let content = null;

  const handleChange = (e) => {
    onChange && onChange(`${name}.value`, e.target.value);
  };

  switch (questionType) {
    case INPUT_TYPE.TEXT: {
      if (viewOnly) {
        content = (
          <Box marginBottom={2}>
            <Typography color="textPrimary" gutterBottom variant="body1">
              {question}
            </Typography>
            <Typography variant="body2">{value}</Typography>
          </Box>
        );
      } else {
        content = (
          <Input
            className={classes.input}
            readOnly={readOnly}
            label={<HelpContentModal content={helpContent} label={question} />}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
          />
        );
      }
      break;
    }
    case INPUT_TYPE.MULTILINE: {
      if (viewOnly) {
        content = (
          <Box marginBottom={2}>
            <Typography color="textPrimary" gutterBottom variant="body1">
              {question}
            </Typography>
            <Typography variant="body2">{value}</Typography>
          </Box>
        );
      } else {
        content = (
          <Input
            className={classes.input}
            multiline
            rows={4}
            rowsMin={4}
            label={<HelpContentModal content={helpContent} label={question} />}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            readOnly={readOnly}
          />
        );
      }
      break;
    }
    case INPUT_TYPE.RADIO: {
      if (viewOnly) {
        content = (
          <Box marginBottom={2}>
            <Typography color="textPrimary" gutterBottom variant="body1">
              {question}
            </Typography>
            <Typography variant="body2">{value}</Typography>
          </Box>
        );
      } else {
        content = (
          <Box marginBottom={2}>
            <FormControl>
              <FormLabel>
                <HelpContentModal content={helpContent} label={question} />
              </FormLabel>
              {placeholder && <FormHelperText>{placeholder}</FormHelperText>}
              <RadioGroup
                name="choices"
                value={value}
                onChange={handleChange}
              >
                {choices.map((i, idx) => (
                  <FormControlLabel
                    classes={{
                      label: "radio-label"
                    }}
                    key={idx}
                    value={i}
                    control={<Radio size="small" />}
                    label={i}

                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        );
      }
      break;
    }
    case INPUT_TYPE.CHECKBOX: {
      content = (
        <Box marginBottom={2}>
          <FormControl>
            <FormLabel>
              <HelpContentModal content={helpContent} label={question} />
            </FormLabel>
            {placeholder && <FormHelperText>{placeholder}</FormHelperText>}
            <CheckboxGroup
              size="small"
              value={value}
              onChange={handleChange}
              choices={choices}
              disabled={viewOnly}
            />
          </FormControl>
        </Box>
      );
      break;
    }
  }
  return content;
};

export const FormBlock = ({ name, block, classes, onChange, viewOnly, readOnly, index }) => {
  switch (block.type) {
    case BLOCK_TYPES.TITLE: {
      return <TitleBlock {...block} classes={classes} />;
    }
    case BLOCK_TYPES.QUESTION: {
      return (
        <QuestionBlock
          viewOnly={viewOnly}
          readOnly={readOnly}
          {...block}
          classes={classes}
          name={name}
          onChange={onChange}
        />
      );
    }
    case BLOCK_TYPES.QUESTIONS_TABLE: {
      return (
        <TableBlock
          {...block}
          classes={classes}
          name={name}
          onChange={onChange}
          viewOnly={viewOnly}
          readOnly={readOnly}
        />
      );
    }
    case BLOCK_TYPES.DIVIDER: {
      return <DividerBlock viewOnly={viewOnly} block={block} index={index} />;
    }
    default:
      return 'Not implemented';
  }
};
